import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Stack, Container, Grid } from "@mui/material";

import Logo from "../assets/img/logo.svg";

import { NavigationComponent } from "./navigation";

import QRScanner from "qr-scanner";

import { useAppSelector } from "../redux/hooks";
import { getApp } from "../redux/app.slice";

export const AttendanceComponent = () => {
  const navigate = useNavigate();
  const app = useAppSelector(getApp);

  useEffect(() => {
    if (!app.isLoggedIn) navigate("/");
  }, [app.isLoggedIn, navigate]);

  useEffect(() => {
    const video_element = document.getElementById(
      "video_scanner"
    ) as HTMLVideoElement;
    if (video_element) {
      const scanner = new QRScanner(
        video_element,
        (result) => {
          if (result && app.student) {
            scanner.stop();
            let data = encodeURIComponent(result.data);
            window.location.href = `${process.env.REACT_APP_APP_URL}attendance/${data}/${app.student.id}/${app.student.secret}`;
          }
        },
        {
          highlightScanRegion: true,
          returnDetailedScanResult: true,
        }
      );
      scanner.start();
    }
  }, [navigate, app.student]);

  return (
    <>
      <NavigationComponent />
      <Container maxWidth="sm" style={{ margin: "2em auto" }}>
        <Stack spacing={2}>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ marginBottom: "1em" }}
          >
            <img
              src={Logo}
              width={100}
              alt="London School of Commerce Group of Colleges Logo"
            />
          </Grid>
          <video id="video_scanner" height="100%" width="100%"></video>
        </Stack>
      </Container>
    </>
  );
};
